import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";
import couterpart from 'counterpart';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

class CardPrintTail extends Component {
  constructor () {
    super();
    this.state = {
      status: '0',
      count: 0
    };
  }

  componentDidMount () {
  }

  viewDetails() {

    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
      WorkOrderUtil.removeItem('prod.fromDate')
      WorkOrderUtil.removeItem('prod.fromDate') 
      WorkOrderUtil.saveItem('prod.deadline', 1)     
      this.props.history.push("/products?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isShipping()){
      WorkOrderUtil.removeItem('shipOrders.fromDate')
      WorkOrderUtil.removeItem('shipOrders.fromDate')
      if (this.props.deadline == 0){
        WorkOrderUtil.saveItem('shipOrders.deadline', undefined)
      } else {
        WorkOrderUtil.saveItem('shipOrders.deadline', 1)
      }
      
      WorkOrderUtil.saveItem('shipOrders.reprintTail', this.props.reprintTail)
      this.props.history.push("shipWorkOrderPrint?caller=0&print=1");
      return;
    }  
  }

  render() {
    return(
      <Card style={{ width: '18rem' }}>
        <Card.Body>
          <Card.Title> { couterpart.translate('reprint_tail_title') } </Card.Title>
          <Card.Text>
            { couterpart.translate('reprint_tail_desc') }
          </Card.Text>
          <Button className="myButton" onClick={this.viewDetails.bind(this)}>{ couterpart.translate('wo_goto_details') }</Button>
        </Card.Body>
      </Card>        
    );
  }
}

export default withRouter(CardPrintTail);